import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Term, TermsResult } from '../interfaces';
import { AuthService } from '../../services/auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class TermsDataService {

  private uri: string = `${environment.apiUrl}`;
  private headers:any ;

  constructor(
    private http: HttpClient
  ) {
    const jsonAuth = localStorage.getItem(AuthService.ATUH_STORAGE_KEY);
    if (jsonAuth) {
      const token = JSON.parse(jsonAuth)?.token;
      if (token) {
        this.headers = new HttpHeaders({
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin':'*',
          authorization: 'Bearer ' + token,
        });
      } 
    }
  }

  getTerms(): Observable<TermsResult|any> {
    return this.http.get(this.uri + "termes-of-use/all");
  }

  getTermsByApp(): Observable<TermsResult|any> {
    return this.http.get(this.uri + "termes-of-use");
  }

  addTerm(data: any): Observable<Term|any> {
    return this.http.post(this.uri + 'termes-of-use/add', data);
  }

  updateTerm(data: any,id:any): Observable<Term|any> {
    return this.http.post(this.uri + 'termes-of-use/update'+ `/${id}`, data);
  }

  deleteTerm(data: Term): Observable<null|any> {
    return this.http.put(this.uri + "/update_active" + `/${data.id}`, "");
  }

}
